module.exports = __webpack_public_path__ + "img/office-logo.03a5dd32.png";